/**
 * VIP 日期展示：库内仍是 yyyy-MM-dd 的起止两个字段。
 * 页面合成一栏，格式 yyyy/mm/dd-yyyy/mm/dd；空值展示为 —。
 * 仍兼容历史 8 位 yyyymmdd。
 */
function toSlashDate (value) {
  if (value == null || value === '') {
    return ''
  }
  const text = String(value).trim()
  if (!text) {
    return ''
  }
  if (/^\d{8}$/.test(text)) {
    return text.slice(0, 4) + '/' + text.slice(4, 6) + '/' + text.slice(6, 8)
  }
  if (/^\d{4}-\d{2}-\d{2}$/.test(text)) {
    return text.replace(/-/g, '/')
  }
  return text
}

function formatVipDate (value) {
  const text = toSlashDate(value)
  return text || '—'
}

function formatVipDateRange (start, end) {
  const startText = toSlashDate(start)
  const endText = toSlashDate(end)
  if (!startText && !endText) {
    return '—'
  }
  if (startText && endText) {
    return startText + '-' + endText
  }
  return startText || endText
}

module.exports = {
  formatVipDate,
  formatVipDateRange
}
